import React from "react"
import PropTypes from "prop-types"
import ConnectMemberCard from './ConnectMemberCard'

class Connects extends React.Component {
  renderConnects() {
    return this.props.connectedUsers.map((connect, i) => {
      const connectUser = (this.props.currentUserId === connect.requestor_id ? connect.requestee : connect.requestor)

      return (
        <ConnectMemberCard
          key={connect.id || i}
          user={connectUser}
          missingImg={this.props.missingImg}
          premiumUser={this.props.premiumUser}
          variant="grid"
        />
      )
    })
  }

  render() {
    return (
      <div className="connectsMemberGrid">
        {this.renderConnects()}
      </div>
    )
  }
}

Connects.propTypes = {
  missingImg: PropTypes.string.isRequired,
  currentUserId: PropTypes.number.isRequired,
  connectedUsers: PropTypes.array.isRequired,
  premiumUser: PropTypes.bool,
}

Connects.defaultProps = {
  premiumUser: false,
}

export default Connects
